__turbopack_context__.v({
  "inputDisabled": "Textarea-module__Pv3j6G__inputDisabled",
  "textarea": "Textarea-module__Pv3j6G__textarea",
  "textareaContainer": "Textarea-module__Pv3j6G__textareaContainer",
  "textareaDisabled": "Textarea-module__Pv3j6G__textareaDisabled",
  "textarea__iconHelper": "Textarea-module__Pv3j6G__textarea__iconHelper",
});
